import { CustomDataTargetType } from "../../types/dto";
import { isMockMode, post, simulateDelay } from "../api";

// takes:
//     targetId (Guid) for the offering or subscription you want to create custom data for
//     targetType (int) to specify whether it's an offering (0) or subscription (1)
export interface CreateCustomDataRequest {
	targetId: string;
	targetType: CustomDataTargetType;
}

export const addCustomData = (data: CreateCustomDataRequest) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post("CustomData/Create", data, {
		successMessage: "Custom Data successfully added",
	});
};
